import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightCircle, Zap, Target, Gauge, Smartphone } from "lucide-react"; // Adicionar mais ícones

function LandingPage() {
  return (
    <div className="flex flex-col items-center">
      {/* Hero Section */}
      <section className="w-full bg-gradient-to-r from-blue-50 to-blue-100 dark:from-gray-800 dark:to-gray-900 text-center py-20 px-4">
        <div className="container mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-brand-blue dark:text-blue-300 mb-4 leading-tight">
            The Tennis Strings Platform
          </h1>
          <p className="text-lg md:text-xl text-medium-text dark:text-gray-300 mb-8 max-w-2xl mx-auto">
            Two powerful tools for tennis players: measure your racquet's string tension with your phone, and get personalized string recommendations with Tennis String Coach powered by AI.
          </p>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-4">
            <Link
              to="/analyzer"
              className="inline-flex items-center px-8 py-3 bg-brand-blue text-white text-lg font-semibold rounded-lg shadow-lg hover:bg-blue-700 dark:hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-300 transform hover:scale-105"
            >
              Analyze Tension
              <ArrowRightCircle size={22} className="ml-2" />
            </Link>
            <Link
              to="/coach"
              className="inline-flex items-center px-8 py-3 bg-green-600 text-white text-lg font-semibold rounded-lg shadow-lg hover:bg-green-700 dark:hover:bg-green-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-300 transform hover:scale-105"
            >
              Tennis String Coach
              <ArrowRightCircle size={22} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="container mx-auto py-16 px-4">
        <h2
          className="text-3xl font-bold text-center dark:text-gray-100 mb-12"
          style={{ color: "black" }}
        >
          Why use The Tennis Strings?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Feature 1: Precisão */}
          <div className="flex flex-col items-center text-center p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
            <Gauge
              size={48}
              className="text-brand-blue dark:text-blue-400 mb-4"
            />
            <h3 className="text-xl font-semibold text-dark-text dark:text-gray-100 mb-2">
              Sound Accuracy
            </h3>
            <p className="text-medium-text dark:text-gray-300 text-sm">
              Our advanced acoustic analysis estimates tension based on sound
              frequency.
            </p>
          </div>
          {/* Feature 2: Tennis String Coach */}
          <div className="flex flex-col items-center text-center p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border-2 border-green-500">
            <Target
              size={48}
              className="text-green-600 dark:text-green-400 mb-4"
            />
            <h3 className="text-xl font-semibold text-green-700 dark:text-green-200 mb-2">
              Tennis String Coach
            </h3>
            <p className="text-medium-text dark:text-gray-300 text-sm">
              Get personalized string recommendations powered by AI. Find the perfect string for your game and needs, instantly.
            </p>
          </div>
          {/* Feature 3: Acessível */}
          <div className="flex flex-col items-center text-center p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
            <Smartphone
              size={48}
              className="text-brand-blue dark:text-blue-400 mb-4"
            />
            <h3 className="text-xl font-semibold text-dark-text dark:text-gray-100 mb-2">
              Use Only Your Phone
            </h3>
            <p className="text-medium-text dark:text-gray-300 text-sm">
              No expensive equipment needed. Just your smartphone or computer
              with a microphone.
            </p>
          </div>
          {/* Feature 4: Completely Free */}
          <div className="flex flex-col items-center text-center p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
            <Zap
              size={48}
              className="text-brand-blue dark:text-blue-400 mb-4"
            />
            <h3 className="text-xl font-semibold text-dark-text dark:text-gray-100 mb-2">
              Completely Free
            </h3>
            <p className="text-medium-text dark:text-gray-300 text-sm">
              Access the tool at no cost and optimize your game as often as you like.
            </p>
          </div>
        </div>
      </section>

      {/* How it Works Section (Opcional) */}
      <section className="w-full bg-gray-50 dark:bg-gray-800 py-16 px-4">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl font-bold text-dark-text dark:text-gray-100 mb-12">
            How It Works?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="flex flex-col items-center">
              <div className="bg-brand-blue text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold mb-4">
                1
              </div>
              <h3 className="text-lg font-semibold mb-2 dark:text-gray-100">
                Record the Sound
              </h3>
              <p className="text-medium-text dark:text-gray-300 text-sm">
                Hold the microphone close and tap the string.
              </p>
            </div>
            <div className="flex flex-col items-center">
              <div className="bg-brand-blue text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold mb-4">
                2
              </div>
              <h3 className="text-lg font-semibold mb-2 dark:text-gray-100">
                Analyze
              </h3>
              <p className="text-medium-text dark:text-gray-300 text-sm">
                Click analyze to process the audio.
              </p>
            </div>
            <div className="flex flex-col items-center">
              <div className="bg-brand-blue text-white rounded-full w-12 h-12 flex items-center justify-center text-xl font-bold mb-4">
                3
              </div>
              <h3 className="text-lg font-semibold mb-2 dark:text-gray-100">
                See the Tension
              </h3>
              <p className="text-medium-text dark:text-gray-300 text-sm">
                Receive the estimated tension in pounds (lbs).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section (Opcional) */}
      <section className="container mx-auto text-center py-16 px-4">
        <h2
          className="text-2xl md:text-3xl font-bold dark:text-gray-100 mb-4"
          style={{ color: "black" }}
        >
          Ready to optimize your racquet?
        </h2>
        <p
          className="text-lg text-medium-text dark:text-gray-300 mb-8 max-w-xl mx-auto"
          style={{ color: "black" }}
        >
          Start measuring your string tension right now and feel the difference
          in your game.
        </p>
        <Link
          to="/analyzer"
          className="inline-flex items-center px-8 py-3 bg-brand-blue text-white text-lg font-semibold rounded-lg shadow-lg hover:bg-blue-700 dark:hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-300 transform hover:scale-105"
        >
          Get Started Now
          <ArrowRightCircle size={22} className="ml-2" />
        </Link>
      </section>
    </div>
  );
}

export default LandingPage;
